import { generateDenominatorNumerator } from '~/bootcamp/Activities/Fractions/Fractions.utils'

import { getRangesByDifficulty } from './constants'

/**
 * Responsible to generate final term after adjustment and shuffle
 * @param difficultyLevel
 * @param taskHistory
 * @returns { numerator1: number;  numerator2: number; denominator: number }
 */
export function generateTerms(
  difficultyLevel: number,
  taskHistory: number[],
): { numerator1: number; denominator: number; numerator2: number } {
  const { minNumerator, maxNumerator, minDenominator, maxDenominator } = getRangesByDifficulty(difficultyLevel)

  const { numerator: numerator1, denominator } = generateDenominatorNumerator(
    minNumerator,
    maxNumerator,
    minDenominator,
    maxDenominator,
    taskHistory,
  )
  const { numerator: numerator2 } = generateDenominatorNumerator(
    minNumerator,
    Math.min(denominator - 1, maxNumerator),
    minDenominator,
    maxDenominator,
    taskHistory,
  )

  if (numerator1 / denominator === numerator2 / denominator) {
    return generateTerms(difficultyLevel, taskHistory)
  }

  return { numerator1, numerator2, denominator }
}
